module.exports = __webpack_public_path__ + "static/media/hand-point-right.1433aa5b.svg";